import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { IconClose } from '@travel-frontend/icons';
import { HotlineMobile } from '../../../../../../../../components/HotlineBarNew/components/HotlineBarFixed/components/Hotline/components/Mobile/index.js';
import { Container } from '../../../../../../../../components/HotlineBarNew/components/HotlineBarFixed/components/Layout/components/Container.js';
import { Control } from '../../../../../../../../components/HotlineBarNew/components/HotlineBarFixed/components/Layout/components/Control.js';
import { Content } from '../../../../../../../../components/HotlineBarNew/components/HotlineBarFixed/components/Layout/components/Mobile/components/Content.js';
import { MobileContentContainer } from '../../../../../../../../components/HotlineBarNew/components/HotlineBarFixed/components/Layout/components/Mobile/components/MobileContentContainer.js';
import { LabelSmall } from '../../../../../../../../primitives/index.js';
import { HEADER_QA_ID, qaId } from '../../../../../../../../utils/qaId.js';
import { SPACING_XSMALL } from '../../../../../../../../utils/spacingLegacy.js';
export const LayoutMobile = ({
  phoneNumber,
  handleClick,
  openingHours,
  imageUrl,
  headline
}) => _jsxs(Container, {
  spacing: SPACING_XSMALL,
  direction: "row",
  children: [_jsxs(MobileContentContainer, {
    href: `tel:${phoneNumber}`,
    "data-cy": qaId(HEADER_QA_ID, 'hotline'),
    "data-testid": qaId(HEADER_QA_ID, 'hotline'),
    children: [imageUrl && _jsx("img", {
      src: imageUrl,
      alt: ""
    }), _jsxs(Content, {
      children: [_jsx(LabelSmall, {
        color: "contentInversePrimary",
        truncate: true,
        children: headline
      }), _jsx(HotlineMobile, {
        openingHours: openingHours,
        phoneNumber: phoneNumber
      })]
    })]
  }), _jsx(Control, {
    onClick: handleClick,
    children: _jsx(IconClose, {})
  })]
});